module.exports = __webpack_public_path__ + "img/screen-manual-8.24339a4b.png";